// extracted by mini-css-extract-plugin
export default {"progressBarTitle":"ProgressBarTitle_progressBarTitle__6md-P"};